import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NavController, IonPopover, MenuController } from '@ionic/angular';
import { TranslateCompiler, TranslateService } from '@ngx-translate/core';
import { CommonUsecaseService } from 'src/app/services/shared/common-usecase.service';
import { HttpService } from 'src/app/services/shared/http.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  @Input() route: string = '';
  @ViewChild('userPopover') userPopover!: IonPopover;

  popoverEvent: any;
  isUserPopoverOpen = false;
  isLangPopoverOpen = false;
  langPopoverEvent: any;
  isMainContentVisible: boolean = true;
  userDetails = JSON.parse(localStorage.getItem('authUser') || '{}');
  guser: any;

  searchForm: FormGroup = this.fb.group({
    searchQuery: [''],
  });

  ngOnInit(): void {
    this.activedRoute.queryParams.subscribe((params) => {
      this.searchForm.get('searchQuery')?.setValue(params['search'] || '');
    });
  }

  get isWeb(): boolean {
    return window.innerWidth >= 768 ? true : false;
  }

  logout() {
    this.userPopover.dismiss();
    localStorage.clear();
    this.navCtrl.navigateRoot(['./login']);
    if (window.location.href.split('/').includes('care-smbt.synth365.com')) {
      localStorage.setItem('connectFor', 'Clinics');
    } else {
      localStorage.setItem('connectFor', 'beta');
    }
  }

  constructor(
    public router: Router,
    private httpService: HttpService,
    private fb: FormBuilder,
    private navCtrl: NavController,
    private activedRoute: ActivatedRoute,
    private menuController: MenuController,
    private commonUsecaseService: CommonUsecaseService,
    private translate: TranslateService
  ) {
    this.guser = this.httpService.ssGuser();
    const selectedLang = localStorage.getItem('selectedLang') || 'en';
    this.translate.use(selectedLang);
  }

  onSearch() {
    this.commonUsecaseService.headerSearchText.next(
      this.searchForm.get('searchQuery')?.value || ''
    );
    this.router.navigate(['/patient-list'], {
      queryParams: { search: this.searchForm.get('searchQuery')?.value },
    });
  }

  clearSearch() {
    this.searchForm.reset();
    this.commonUsecaseService.headerSearchText.next(
      this.searchForm.get('searchQuery')?.value || ''
    );
  }

  openPopover(ev: any) {
    this.popoverEvent = ev;
    this.isUserPopoverOpen = true;
  }

  goBack() {
    if (this.route) {
      this.router.navigate([this.route]);
    } else {
      console.log('No navigation route provided!');
    }
  }

  openMenu() {
    this.menuController.enable(true, 'start');
    this.menuController.open('start');
  }

  changeLanguage(lang: string) {
    // Example if using ngx-translate
    this.translate.use(lang);
    localStorage.setItem('selectedLang', lang);

    this.isLangPopoverOpen = false;
  }

  openLangPopover(ev: any) {
    this.langPopoverEvent = ev;
    this.isLangPopoverOpen = true;
  }

  fallbackToLoggedInUser() {
    const loggedUser = JSON.parse(localStorage.getItem('authUser') || '{}');
    localStorage.setItem('userDetails', JSON.stringify(loggedUser));
    window.location.reload();
  }
}
